// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red[data-v-641c94e4]{color:red}.labelBox[data-v-641c94e4]{font-size:14px;color:#666}.marketingActivitiesName[data-v-641c94e4]{width:100%;height:30px;line-height:30px;border:1px solid #e3e2e2;border-radius:3px}[data-v-641c94e4] .el-tabs__item{font-size:15px}[data-v-641c94e4] .el-select .el-input__inner{height:30px;line-height:30px}[data-v-641c94e4] .el-input__icon{line-height:30px}", ""]);
// Exports
module.exports = exports;
